import { render, staticRenderFns } from "./ConsultaSis.vue?vue&type=template&id=13e171b2&"
import script from "./ConsultaSis.vue?vue&type=script&lang=js&"
export * from "./ConsultaSis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports